const adUnits = {
  panorama: {
    name: 'JOKER_Panorama',
    sizes: [
      [320, 50],
      [320, 160],
      [320, 320],
      [728, 90],
      [728, 180],
      [980, 120],
      [980, 240],
    ],
    sizeMapping: [
      {
        viewport: [1010, 0],
        sizes: [
          [980, 120],
          [980, 240],
        ],
      },
      {
        viewport: [758, 0],
        sizes: [
          [728, 90],
          [728, 180],
        ],
      },
      {
        viewport: [0, 0],
        sizes: [
          [320, 50],
          [320, 160],
          [320, 320],
        ],
      },
    ],
  },
  insider: {
    name: 'JOKER_Square',
    sizes: [
      [300, 250],
      [300, 600],
    ],
    sizeMapping: [
      {
        viewport: [758, 0],
        sizes: [[300, 600]],
      },
      {
        viewport: [0, 0],
        sizes: [[300, 250]],
      },
    ],
  },
};

export default adUnits;
